/* Ricerca per SKU sul frontend (richiesta ufficio, 2026-07).
   Shopify NON cerca negli SKU di default: serve passare options[fields] con variants.sku
   sia alla ricerca predittiva (/search/suggest) sia alla pagina /search.
   ATTENZIONE: options[fields] SOSTITUISCE i campi di ricerca di default, quindi la lista
   deve includere anche quelli standard (title, body, vendor, ecc.) o si perde la ricerca
   normale. File nostro + patch a runtime (non si modifica assets/search.js di Foxecom,
   che gli update del tema sovrascrivono). Caricato con defer da layout/theme.liquid. */
(function () {
  var FIELDS = 'title,body,vendor,product_type,tag,variants.title,variants.sku,variants.barcode';

  /* 1) Ricerca predittiva: patch del prototipo (vale anche per istanze già create) */
  if (window.customElements) {
    customElements.whenDefined('predictive-search').then(function () {
      var proto = customElements.get('predictive-search').prototype;
      if (!proto || proto.__wsSkuPatched) return;
      proto.__wsSkuPatched = true;
      var origSetupURL = proto.setupURL;
      if (origSetupURL) {
        proto.setupURL = function () {
          var url = origSetupURL.call(this);
          url.searchParams.set('resources[options][fields]', FIELDS);
          return url;
        };
      }
      /* onSubmit col filtro product_type costruisce l'URL a mano bypassando il form:
         re-implementato identico + options[fields] (submit normali coperti dall'hidden input) */
      var origOnSubmit = proto.onSubmit;
      if (origOnSubmit) {
        proto.onSubmit = function (event) {
          var productType = this.searchProductTypes && this.searchProductTypes.value;
          if (!productType) return origOnSubmit.call(this, event);
          var query = this.getQuery();
          if (query.length === 0 || query.indexOf('product_type:') === 0) return origOnSubmit.call(this, event);
          event.preventDefault();
          var params = new URLSearchParams();
          params.set('q', 'product_type:' + productType + ' AND ' + query);
          params.set('options[prefix]', 'last');
          params.set('options[fields]', FIELDS);
          window.location.href = this.form.getAttribute('action') + '?' + params.toString();
        };
      }
    });
  }

  /* 2) Pagina /search: hidden input in ogni form di ricerca (header, drawer, main-search) */
  function addHiddenInputs(root) {
    (root || document).querySelectorAll('form[action*="/search"]').forEach(function (form) {
      if (form.querySelector('input[name="options[fields]"]')) return;
      var inp = document.createElement('input');
      inp.type = 'hidden';
      inp.name = 'options[fields]';
      inp.value = FIELDS;
      form.appendChild(inp);
    });
  }

  /* 3) Link verso /search?q=... (es. "vedi tutti i risultati" nel popup, renderizzato
        server-side dopo il fetch): delega sul click, aggiunge il parametro se manca */
  function fixSearchLink(e) {
    var a = e.target.closest && e.target.closest('a[href*="/search?"]');
    if (!a) return;
    try {
      var url = new URL(a.href, window.location.origin);
      if (url.pathname.indexOf('/search') !== -1 && !url.searchParams.has('options[fields]')) {
        url.searchParams.set('options[fields]', FIELDS);
        a.href = url.toString();
      }
    } catch (_) { /* href non valido: lascia stare */ }
  }

  function init() {
    addHiddenInputs(document);
    document.addEventListener('click', fixSearchLink, true);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
